
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <div className="text-red-500 mb-4">Error: {error}</div>
      <Button onClick={onRetry} variant="default">
        Retry
      </Button>
    </div>
  );
};
